import { render, staticRenderFns } from "./FacilityEditCities.vue?vue&type=template&id=09f20350&"
import script from "./FacilityEditCities.vue?vue&type=script&lang=js&"
export * from "./FacilityEditCities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports